namespace Portico.Models.Enterprise {
    import pmg = Portico.Models.Gateway;
    import psgm = apigateway.models;

    export interface IPayorCoverageArea {
        state: string;
        externalIdType: pmg.ExternalIdType;
        externalId: string;
    }

    export class PayorCoverageArea implements IPayorCoverageArea {
        state: string;
        externalIdType: pmg.ExternalIdType;
        externalId: string;

		constructor(obj?: IPayorCoverageArea | psgm.PayorCoverageAreaModel) {
            this.state = '';
            this.externalIdType = null;
            this.externalId = '';

            if (obj) {
                this.state = obj.state || '';
				this.externalIdType = <pmg.ExternalIdType><unknown>obj.externalIdType || null;
				this.externalId = obj.externalId || '';
            }
        }
    }

}